
import Vue from "vue";
import {Component, Prop} from "vue-property-decorator";

//<paz-tooltip-text tooltip="this is the tooltip">The text here</paz-tooltip-text>
@Component
export default class PazTooltipText extends Vue {

  @Prop({default: ''})
  public tooltip!: string;
}
